import React from 'react';
import { DetailBuilder } from '@eigen3m/react-base-frontend';
import { Form, Image } from 'antd';
import { Maps } from '@components/maps';
import { HTMLToReact } from '@components/html-react';

export function DetailEventInformation({ value, subKey }: { value?: any; subKey?: any }) {
  return (
    <DetailBuilder
      columns={[
        {
          fields: [
            {
              gridColumn: { xl: 4, lg: 8, md: 12, sm: 24 },
              label: 'Department',
              name: [...subKey, 'department'],
              fieldType: 'text',
              renderTextProps: {
                renderValue(value) {
                  return value?.name;
                },
                defaultRender: () => '-',
              },
            },
            {
              gridColumn: { xl: 4, lg: 8, md: 12, sm: 24 },
              label: 'Class',
              name: [...subKey, 'department_class'],
              fieldType: 'text',
              renderTextProps: {
                renderValue(value) {
                  return value?.name;
                },
                defaultRender: () => '-',
              },
            },
            {
              gridColumn: { xl: 16, lg: 8, md: 12, sm: 24 },
              label: 'Event Category',
              name: [...subKey, 'event_category'],
              fieldType: 'text',
              renderTextProps: {
                renderValue(value) {
                  return value?.name;
                },
                defaultRender: () => '-',
              },
            },
            {
              gridColumn: { xl: 4, lg: 8, md: 12, sm: 24 },
              label: 'Banner in Homepage',
              name: [...subKey, 'banner_in_homepage'],
              fieldType: 'text',
              renderTextProps: {
                renderValue(value) {
                  return value ? 'Yes' : 'No';
                },
                defaultRender: () => '-',
              },
            },
            {
              gridColumn: { xl: 16, lg: 16, md: 10, sm: 24 },
              label: 'Banner in Event Category',
              name: [...subKey, 'banner_in_event_category'],
              fieldType: 'text',
              renderTextProps: {
                renderValue(value) {
                  return value ? 'Yes' : 'No';
                },
                defaultRender: () => '-',
              },
            },
            {
              gridColumn: { span: 24 },
              label: 'Event Name',
              name: [...subKey, 'name'],
              fieldType: 'text',
              renderTextProps: {
                renderValue(value) {
                  return value;
                },
                defaultRender: () => '-',
              },
            },
            {
              gridColumn: { span: 24 },
              renderField(form) {
                const documentUrl = form.getFieldValue([...subKey, 'banner_url']);
                const assetUrl = process.env.REACT_APP_BASE_ASSET_URL;
                const imageUrl = assetUrl && documentUrl ? assetUrl + documentUrl : 'error';
                return (
                  <Form.Item label="Banner">
                    {documentUrl ? (
                      <Image
                        width={documentUrl !== 'error' ? 'auto' : 200}
                        height={150}
                        src={imageUrl}
                        fallback="data:image/png;base64,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"
                      />
                    ) : (
                      '-'
                    )}
                  </Form.Item>
                );
              },
            },
            {
              gridColumn: { xl: 4, lg: 4, md: 4, sm: 24 },
              label: 'Event Type',
              name: [...subKey, 'event_type'],
              fieldType: 'text',
              renderTextProps: {
                renderValue(value) {
                  return value;
                },
                defaultRender: () => '-',
              },
            },
            {
              gridColumn: { xl: 20, lg: 20, md: 20, sm: 24 },
              label: 'Venue Name',
              name: [...subKey, 'venue'],
              fieldType: 'text',
              renderTextProps: {
                renderValue(value) {
                  return value?.name;
                },
                defaultRender: () => '-',
              },
              customHidden(form) {
                const eventType = form.getFieldValue([...subKey, 'event_type']);
                return eventType === 'On Site' ? false : true;
              },
            },
            {
              gridColumn: { span: 24 },
              renderField(form) {
                const addressDescription = form?.getFieldValue([...subKey, 'venue', 'address_description']);
                return (
                  <Form.Item name={[...subKey, 'venue', 'address']}>
                    <Maps addressDescription={addressDescription} />
                  </Form.Item>
                );
              },
              customHidden(form) {
                const eventType = form.getFieldValue('event_type');
                return eventType === 'On Site' ? false : true;
              },
            },
            {
              gridColumn: { span: 24 },
              customHidden(form) {
                const eventType = form.getFieldValue([...subKey, 'event_type']);
                const venue = form.getFieldValue([...subKey, 'venue']);
                if (!!eventType && eventType.toLowerCase() === 'on site' && !!venue) {
                  return false;
                } else {
                  return true;
                }
              },
              renderField(form) {
                const address = form.getFieldValue([...subKey, 'venue', 'address']);
                return <Maps value={address} />;
              },
            },
            {
              gridColumn: { span: 24 },
              renderField() {
                return (
                  <Form.Item label="Description" name={[...subKey, 'description']}>
                    <HTMLToReact />
                  </Form.Item>
                );
              },
            },
            {
              gridColumn: { span: 24 },
              renderField() {
                return (
                  <Form.Item label="Terms & Conditions" name={[...subKey, 'term_and_conditions']}>
                    <HTMLToReact />
                  </Form.Item>
                );
              },
            },
          ],
        },
      ]}
    />
  );
}
